import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'hpf-route',
  templateUrl: './route.component.html'
})
export class RouteComponent implements OnInit {

  /** Constructor */
  constructor() {}

  /** Init */
  ngOnInit() {}

}
